import { CircularProgress, styled } from '@mui/material';

export const ContentLoader = styled(CircularProgress)({
  margin: '40px auto',
  display: 'block',
});
